'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var CustomReactSelect = require('./base/CustomReactSelect.js');

/**
 * Select
 *
 * Custom `Select` element based on `react-select`. See https://react-select.com for documentation.
 */
var Select = CustomReactSelect["default"];
Select.displayName = 'Select';
exports.Select = Select;